<template>
  <v-row no-gutters class="login-full">
    
    <v-col md="12" cols="12" v-if="!isShowAddUser">
      <v-card>
        <v-card-title>
          Account User
          <v-btn depressed fab small color="primary" outlined>
            <v-icon>help</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <center>
            <v-autocomplete
              class="pt-5"
              v-model="userTypeAll"
              item-text="userTypeName"
              :items="userTypeAllList"
              name="userTypeaName"
              label="User Type"
              return-object
              outlined
              required
              dense
              small
            ></v-autocomplete>
          </center>
          <v-btn
            depressed
            color="primary"
            v-if="!isShowAddUser"
            class="mx-2"
            @click="showAddUser"
          >
            <v-icon class="mr-2">add</v-icon>
            <span>Add</span>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-data-table
            class="tbl-info"
            :headers="accountHeader"
            :items="accountList"
            :items-per-page="-1"
            fixed-header
            mobile-breakpoint="sm"
            :headers-length="14"
            height="72vh"
            hide-default-footer
          >
            <!-- <template v-slot:item.action="{ item }">
              <v-btn icon depressed color="primary" @click="editAccount(item)">
                <v-icon>edit</v-icon>
              </v-btn>
              <v-btn icon depressed color="error" @click="deleteAccount(item)">
                <v-icon>delete</v-icon>
              </v-btn>
            </template> -->
            <template
              v-slot:body="{ items, pagination }"
              v-if="accountList.length > 0"
            >
              <tbody>
                <tr
                  v-for="item in items"
                  :key="item.name"
                  :style="{
                    backgroundColor:
                      item.statusDate == 'Completed'
                        ? '#bfffc8'
                        : 'transparent',
                  }"
                >
                  <td class="text-left">{{ item.profileName }}</td>
                  <td class="text-left" v-if="isUserName">
                    {{ item.userName }}
                  </td>
                  <!-- <td class="text-center" v-if="!isUserName">
                    <h3>{{ item.idNumber }}</h3>
                  </td> -->
                  <td class="text-center red--text">
                    <h3>{{ item.userTypeName }}</h3>
                  </td>
                  <td class="text-left">{{ item.phone }}</td>
                  <td class="text-left">{{ item.emergencyContact }}</td>
                  <td class="text-left">{{ item.motorLicense }}</td>
                  <td class="text-left">{{ item.drivingLicense }}</td>
                  <td class="text-center">
                    <v-btn
                      icon
                      depressed
                      color="primary"
                      @click="clickHistory(item)"
                    >
                      <v-icon>history</v-icon>
                    </v-btn>

                    <v-btn
                      icon
                      depressed
                      color="primary"
                      @click="clickProfile(item)"
                    >
                      <v-icon>visibility</v-icon>
                    </v-btn>
                    <v-btn
                      icon
                      depressed
                      color="primary"
                      @click="editAccount(item)"
                    >
                      <v-icon>edit</v-icon>
                    </v-btn>
                    <v-btn
                      icon
                      depressed
                      color="error"
                      @click="deleteAccount(item)"
                    >
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col offset-md="3" md="6" cols="12" class="pa-2" v-if="isShowAddUser">
      <v-card class="pa-0">
        <v-card-title>
          Account User
          <v-spacer></v-spacer>
          <v-btn
            depressed
            color="primary"
            v-if="isShowAddUser"
            @click="clickProfileImage()"
          >
            <span>Profile Image</span>
          </v-btn>
          <v-btn
            class="ml-3"
            depressed
            color="primary"
            v-if="isShowAddUser"
            @click="showAddUser"
          >
            <v-icon class="mr-2">list</v-icon>
            <span>List</span>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-form
            ref="form"
            v-model="valid"
            v-on:submit.prevent
            lazy-validation
          >
            <v-row no-gutters>
              <v-col cols="12" md="6" class="px-1">
                <v-text-field
                  v-model="account.profileName"
                  :rules="profileNameRule"
                  label="Profile Name"
                  name="profileName"
                  outlined
                  required
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="3" class="px-1">
                <v-text-field
                  v-model.number="account.percent"
                  label="Percent"
                  name="profileNamesalarypercent"
                  type="number"
                  outlined
                  required
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="3" class="px-1">
                <v-text-field
                  v-model.number="account.salary"
                  label="Salary"
                  name="profileNamesalary"
                  type="number"
                  outlined
                  required
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" class="px-1 text-center">
                <v-text-field
                  v-model="account.userName"
                  :rules="userNameRule"
                  label="User Name"
                  name="userName"
                  outlined
                  required
                  dense
                  autocomplete="email"
                  v-if="isUserName"
                ></v-text-field>
                <!-- <h3 class="red--text">{{ idNumber }}</h3> -->
              </v-col>
              <v-col cols="12" md="6" class="px-1">
                <v-text-field
                  :append-icon="showPass ? 'visibility' : 'visibility_off'"
                  :type="showPass ? 'text' : 'password'"
                  @click:append="showPass = !showPass"
                  v-model="account.password"
                  name="userNamePassword"
                  label="Password"
                  outlined
                  required
                  dense
                  autocomplete="new-password"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" class="px-1">
                <v-autocomplete
                  :rules="[(v) => v.userTypeId != 0 || 'User Type is required']"
                  v-model="account.userType"
                  item-text="userTypeName"
                  :items="userTypeList"
                  name="userTypeName"
                  label="User Type"
                  return-object
                  outlined
                  required
                  dense
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="6" class="px-1">
                <v-autocomplete
                  :rules="[(v) => v.branchId != 0 || 'Branch is required']"
                  v-model="account.branch"
                  item-text="branchName"
                  :items="branchList"
                  name="branchName"
                  label="Branch For Deli "
                  return-object
                  outlined
                  required
                  dense
                >
                  <template v-slot:append-outer>
                    <v-slide-x-reverse-transition mode="out-in">
                      <v-icon
                        color="primary"
                        @click="
                          $router.push({ name: 'branch' }).catch(() => {})
                        "
                        >add_circle</v-icon
                      >
                    </v-slide-x-reverse-transition>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="12" md="2" class="pl-2">
                <v-select
                  v-model="numberNo"
                  :items="numberList"
                  return-object
                  outlined
                  required
                  dense
                ></v-select>
              </v-col>
              <v-col cols="12" md="4" class="pl-2">
                <v-autocomplete
                  v-model="township"
                  :items="tsList"
                  return-object
                  outlined
                  required
                  dense
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="2" class="pl-2">
                <v-select
                  v-model="nep"
                  :items="nepList"
                  return-object
                  outlined
                  required
                  dense
                ></v-select>
              </v-col>
              <v-col cols="12" md="4" class="px-1">
                <v-text-field
                  v-model="nrcnumber"
                  name="accountNrc"
                  dense
                  outlined
                  label="Number"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" class="px-1">
                <v-text-field
                  v-model="account.nrcno"
                  name="accountNrc"
                  dense
                  outlined
                  label="NRC"
                  disabled
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" class="px-1">
                <v-text-field
                  v-model="account.phone"
                  name="accountPhone"
                  dense
                  outlined
                  label="Phone"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="12" class="px-1">
                <v-textarea
                  v-model="account.address"
                  name="accountAddress"
                  label="Address"
                  rows="1"
                  outlined
                  required
                ></v-textarea>
              </v-col>
              <v-col cols="12" md="12" class="px-1">
                <v-text-field
                  v-model="account.emergencyContact"
                  name="emergencyContact"
                  dense
                  outlined
                  label="Emergency Contact No."
                ></v-text-field>
              </v-col>
              <v-col cols="6" md="6">
                <v-menu
                  :close-on-content-click="false"
                  transition="scale-transition"
                  min-width="290px"
                  v-model="fromMenu"
                  offset-y
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="account.joinDate"
                      label="Join Date"
                      prepend-icon="event"
                      hide-details
                      readonly
                      v-on="on"
                      dense
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="fromPicker"
                    @input="fromMenu = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="6" md="6" class="pl-2">
                <v-autocomplete
                  v-model="account.bloodGroup"
                  item-text="bloodgroup"
                  :items="bloodList"
                  name="bloodgroup"
                  label="Blood Group"
                  return-object
                  outlined
                  required
                  dense
                ></v-autocomplete>
              </v-col>
              <v-col cols="6" md="6">
                <v-text-field
                  v-model="account.motorLicense"
                  name="motorlicense"
                  dense
                  outlined
                  label="Motor License"
                ></v-text-field>
              </v-col>
              <v-col cols="6" md="6" class="pl-2">
                <v-text-field
                  v-model="account.drivingLicense"
                  name="drivinglicense"
                  dense
                  outlined
                  label="Driving License"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" class="px-1">
                <v-btn
                  v-if="account.status == 'ADD'"
                  depressed
                  :disabled="!valid"
                  color="success"
                  class="ma-1"
                  @click="addAccount()"
                  >Create Account</v-btn
                >
                <v-btn
                  v-if="account.status == 'UPDATE'"
                  @click="updateAccount"
                  :disabled="!valid"
                  color="success"
                  class="ma-1"
                  depressed
                >
                  <v-icon>edit</v-icon>
                  <span class="ml-2">Update</span>
                </v-btn>
                <!-- <v-btn
                  v-if="account.status == 'UPDATE'"
                  @click="cancelAccount"
                  :disabled="!valid"
                  color="error"
                  class="ma-1"
                  depressed
                  outlined
                >
                  <v-icon>close</v-icon>
                  <span class="ml-2">Cancel</span>
                </v-btn> -->
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-col>
    <v-dialog
      v-model="dialogPayment"
      max-width="400"
      transition="dialog-top-transition"
    >
      <paymentDialog
        @closeDialog="dialogPayment = false"
        :userAccountId="userAccountId"
      />
    </v-dialog>
    <v-col>
      <v-bottom-sheet v-model="dialogProfile" fullscreen scrollable>
        <v-sheet class="information-window-v-sheet tempColor">
          <profileDialog @exist="dialogProfile = false" :profile="profile" />
        </v-sheet>
      </v-bottom-sheet>
    </v-col>
    <v-col>
      <v-bottom-sheet v-model="dialogUserHistory" fullscreen scrollable>
        <v-sheet class="fullscreen">
          <historyUserDialog
            @closeDialog="dialogUserHistory = false"
            :userId="userId"
          />
        </v-sheet>
      </v-bottom-sheet>
    </v-col>
    <v-col>
      <v-dialog
      v-model="dialogDeleteUser"
      width="500"
    >
      <v-card>
        <v-card-title class="green white--text" v-if="userTypeAll.userTypeName=='TERMINATE'">
          Are you sure to active ({{deleteUser.profileName}})?
        </v-card-title>
        <v-card-title class="red white--text" v-else>
          Are you sure to delete ({{deleteUser.profileName}})?
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="dialogDeleteUser = false"
          >
            Cancel
          </v-btn>
          <v-btn
            color="green"
            text
            @click="clickOkDelete()"
            v-if="userTypeAll.userTypeName=='TERMINATE'"
          >
            active
          </v-btn>
          <v-btn
            color="red"
            text
            @click="clickOkDelete()"
            v-else
          >
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    </v-col>
  </v-row>
</template>
  <script>
import accountUserService from "../service/AccountUserService";
import branchService from "../service/BranchService";
import paymentDialog from "@/components/PaymentPhotoDialog.vue";
import profileDialog from "@/components/ProfileDialog.vue";
import historyUserDialog from "@/components/HistoryUserDialog.vue";
export default {
  data() {
    return {
      dialogProfile: false,
      isShowAddUser: false,
      showPass: false,
      valid: false,
      account: {
        branch: {
          branchId: 0,
          branchName: "",
        },
        userType: {
          userTypeId: 0,
          userTypeName: "",
        },
        status: "ADD",
        joinDate: "",
      },
      profileNameRule: [
        (v) => (!!v && v.trim() != "") || "Profile Name is required",
      ],
      userNameRule: [(v) => (!!v && v.trim() != "") || "User Name is required"],
      passwordRules: [(v) => (!!v && v.trim() != "") || "Password is required"],
      addressRules: [(v) => (!!v && v.trim() != "") || "Address is required"],
      accountHeader: [
        { text: "Profile Name", value: "profileName", sortable: false },
         { text: "User Name", value: "userName",sortable: false },
        // { text: "Id", value: "idNumber", sortable: false },
        { text: "User Type", value: "userTypeName", sortable: false },
        { text: "Phone", value: "phone", sortable: false },
        {
          text: "Emergency Contact",
          value: "emergencyContact",
          sortable: false,
        },
        { text: "Motor License", value: "motorLicense", sortable: false },
        { text: "Driving License", value: "drivingLicense", sortable: false },
        { text: "Action", value: "action", sortable: false },
      ],
      accountList: [],
      branchList: [],
      userTypeList: [],
      userList: [],
      // osList: [],
      os: {},
      oneIndex: true,
      fromPicker: new Date().toISOString().substr(0, 10),
      fromMenu: false,
      dialogPayment: false,
      userAccountId: 0,
      profile: {},
      dialogUserHistory: false,
      userId: 0,
      userTypeAll: {},
      userTypeAllList: [],
      isUserName: true,
      idNumber: "",
      bloodList: ["O+", "A+", "A-", "B+", "B-", "AB+", "AB-"],
      numberList: [
        "၁",
        "၂",
        "၃",
        "၄",
        "၅",
        "၆",
        "၇",
        "၈",
        "၉",
        "၁၀",
        "၁၁",
        "၁၂",
        "၁၃",
        "၁၄",
      ],
      numberNo: "",
      tsList: [],
      township: "",
      nepList: ["နိူင်", "ဧည့်", "ပြု"],
      nep: "",
      nrcnumber:"",
      deleteUser:{},
      dialogDeleteUser:false
    };
  },
  mounted: function () {
    this.numberNo = this.numberList[0];
    this.nep = this.nepList[0];
    this.getUserType();
    if (this.$route.query.isShowAddUser != undefined) {
      this.isShowAddUser = this.$route.query.isShowAddUser == "true";
      if (this.oneIndex) {
        this.getBranch();
        //this.getUserType();
        //this.getOnlineshopping();
        this.oneIndex = false;
      }
    }
  },
  methods: {
    getNrc:function(){
        this.account.nrcno = this.numberNo+"/"+this.township+"("+this.nep+")"+this.nrcnumber;
    },
    clickHistory: function (item) {
      this.userId = item.userAccountId;
      this.dialogUserHistory = true;
    },
    clickProfile: function (item) {
      this.dialogProfile = true;
      this.profile = Object.assign({}, item);
    },
    clickProfileImage: function () {
      if (this.account.userAccountId != undefined) {
        this.userAccountId = this.account.userAccountId;
        this.dialogPayment = true;
      }
    },
    formatDate(fromPicker) {
      const [year, month, day] = fromPicker.split("-");
      return `${day}-${month}-${year}`;
    },
    // getOnlineshopping: function () {
    //   osService.getAllOnlineshopping().then((response) => {
    //     this.osList.splice(0, this.osList.length);
    //     this.osList.push(...response);
    //     this.os = this.osList[0];
    //   });
    // },
    addAccount: function () {
      if (this.$refs.form.validate()) {
        var addacc = {
          branchId: this.account.branch.branchId,
          branchName: this.account.branch.branchName,
          userTypeId: this.account.userType.userTypeId,
          userTypeName: this.account.userType.userTypeName,
          // idNumber: this.idNumber,
          profileName: this.account.profileName,
          userName: this.account.userName,
          password: this.account.password,
          nrcno: this.account.nrcno,
          address: this.account.address,
          phone: this.account.phone,
          emergencyContact: this.account.emergencyContact,
          joinDate: this.account.joinDate,
          motorLicense: this.account.motorLicense,
          drivingLicense: this.account.drivingLicense,
          bloodGroup: this.account.bloodGroup,
          salary: this.account.salary,
          percent: this.account.percent,
          osId: this.os.osId,
        };
        accountUserService
          .addAccount(addacc)
          .then(() => {
            this.$swal({
              title: "Successful",
              text: "Added New Account Successful!",
              type: "success",
              timer: 500,
            });
            this.getAccount();
            //this.$refs.form.reset();
            this.isShowAddUser = false;
          })
          .catch((err) => {
            this.isShowAddUser = true;
            this.$swal("Failed", err.response.data.message, "error");
          });
      }
    },
    getAccount: function () {
      accountUserService
        .getAccount(this.userTypeAll.userTypeName)
        .then((response) => {
          this.accountList.splice(0, this.accountList.length);
          this.accountList.push(...response);
        });
    },
    editAccount: function (account) {
      if (this.oneIndex) {
        this.getBranch();
        //this.getUserType();
        //this.getOnlineshopping();
        this.oneIndex = false;
      }
      this.account.status = "UPDATE";
      this.account.userAccountId = account.userAccountId;
      this.account.profileName = account.profileName;
      this.account.userName = account.userName;
      this.account.nrcno = account.nrcno;
      this.account.address = account.address;
      this.account.phone = account.phone;
      this.account.branch.branchId = account.branchId;
      this.account.branch.branchName = account.branchName;
      this.account.userType.userTypeId = account.userTypeId;
      this.account.userType.userTypeName = account.userTypeName;
      // (this.idNumber = account.idNumber),
        (this.account.emergencyContact = account.emergencyContact);
      this.account.joinDate = account.joinDate;
      this.account.motorLicense = account.motorLicense;
      this.account.drivingLicense = account.drivingLicense;
      this.account.bloodGroup = account.bloodGroup;
      this.account.salary = account.salary;
      this.account.percent = account.percent;
      this.os.osId = account.osId;
      this.os.name = account.osName;

      this.isShowAddUser = true;

      let tempNumber = this.account.nrcno.split("/");
      this.numberNo = tempNumber[0];
      let tempTs = tempNumber[1].substring(0,3);
      this.township = tempTs;
      let tempOne = tempNumber[1].split("(");
      let tempTwo = tempOne[1].split(")");
      this.nep = tempTwo[0];
      this.nrcnumber = tempTwo[1];

    },
    updateAccount: function () {
      if (this.$refs.form.validate()) {
        var addacc = {
          userAccountId: this.account.userAccountId,
          branchId: this.account.branch.branchId,
          branchName: this.account.branch.branchName,
          userTypeId: this.account.userType.userTypeId,
          userTypeName: this.account.userType.userTypeName,
          profileName: this.account.profileName,
          userName: this.account.userName,
          // idNumber: this.idNumber,
          password: this.account.password,
          nrcno: this.account.nrcno,
          address: this.account.address,
          phone: this.account.phone,
          emergencyContact: this.account.emergencyContact,
          joinDate: this.account.joinDate,
          motorLicense: this.account.motorLicense,
          drivingLicense: this.account.drivingLicense,
          bloodGroup: this.account.bloodGroup,
          salary: this.account.salary,
          percent: this.account.percent,
          osId: this.os.osId,
        };
        accountUserService
          .updateAccount(addacc)
          .then(() => {
            //this.$swal("Updated Successful", "Account is Updated!", "success");
            this.$swal({
              title: "Successful",
              text: "Account is Updated!",
              type: "success",
              timer: 500,
            });

            this.getAccount();
            //this.$refs.form.reset();
            this.account = {
              branch: {
                branchId: 0,
                branchName: "",
              },
              userType: {
                userTypeId: 0,
                userTypeName: "",
              },
              status: "ADD",
            };
            this.isShowAddUser = false;
          })
          .catch((err) => {
            this.$swal("Failed", err.response.data.message, "error");
          });
      }
    },
    deleteAccount: function (account) {
      console.log(account);
      this.deleteUser = Object.assign({},account);
      this.dialogDeleteUser = true;
    },
    clickOkDelete:function(){
      this.dialogDeleteUser = false;
accountUserService
        .deleteAccount(this.deleteUser)
        .then(() => {
          this.$swal({
            title: "Successful",
            text: "Account is Deleted!",
            type: "success",
            timer: 500,
          });

          this.getAccount();
          this.$refs.form.reset();
          this.account.status = "ADD";
        })
        .catch((err) => {
          if (err.response != undefined) {
            this.$swal(
              "Failed",
              "This data is used in somewhere Or " + err.response.data.message,
              "error"
            );
          }
        });
    },
    cancelAccount: function () {
      this.$refs.form.reset();
      this.account = {
        branch: {
          branchId: 0,
          branchName: "",
        },
        userType: {
          userTypeId: 0,
          userTypeName: "",
        },
        status: "ADD",
      };
      this.isShowAddUser = false;
    },
    getBranch: function () {
      branchService.getAllBranch().then((response) => {
        this.branchList.splice(0, this.branchList.length);
        this.branchList.push(...response);
      });
    },
    getUserType: function () {
      accountUserService.getUserType().then((response) => {
        this.userTypeList.splice(0, this.userTypeList.length);
        this.userTypeList.push(...response);
        this.userTypeAllList.splice(0, this.userTypeAllList.length);
        var tempObj = {};
        tempObj.userTypeId = 0;
        tempObj.userTypeName = "ALL";
        this.userTypeAllList.push(tempObj);
        this.userTypeAllList.push(...response);
        var tempObj = {};
        tempObj.userTypeId = -1;
        tempObj.userTypeName = "TERMINATE";
        this.userTypeAllList.push(tempObj);
        this.userTypeAllList.push(...response);
        this.userTypeAll = this.userTypeAllList[3];
      });
    },
    showAddUser: function () {
      if (this.isShowAddUser == false) {
        (this.account = {
          branch: {
            branchId: 0,
            branchName: "",
          },
          userType: {
            userTypeId: 0,
            userTypeName: "",
          },
          status: "ADD",
        }),
          (this.isShowAddUser = true);
        if (this.oneIndex) {
          this.getBranch();
          //this.getUserType();
          //this.getOnlineshopping();
          this.oneIndex = false;
        }
      } else {
        this.isShowAddUser = false;
      }
      this.changeRouter(this.isShowAddUser);
    },
    changeRouter: function (isShowAddUser) {
      let query = {
        isShowAddUser: isShowAddUser,
      };
      this.$router
        .replace({
          name: "account",
          query,
        })
        .catch(() => {});
    },
  },
  watch: {

    account() {
      this.account.joinDate = this.formatDate(this.fromPicker);
    },
    fromPicker() {
      this.account.joinDate = this.formatDate(this.fromPicker);
    },
    userTypeAll() {
      this.getAccount();
    },
    // "account.phone": function () {
    //   this.account.userName = this.account.phone;
    // },
    // "account.userType": function () {
    //   accountUserService
    //     .getUserCount(this.account.userType.userTypeName)
    //     .then((response) => {
    //       this.idNumber = response.idNumber;
    //     })
    //     .catch((err) => {
    //       this.$swal("Failed", err.response.data.message, "error");
    //     });
    // },
    numberNo() {
      this.tsList.splice(0);
      if (this.numberNo == "၁") {
        this.tsList.push("အဂယ");
        this.tsList.push("ဗမန");
        this.tsList.push("ဒဖယ");
        this.tsList.push("ဟပန");
        this.tsList.push("ကမန");
        this.tsList.push("ကပတ");
        this.tsList.push("ခဘဒ");
        this.tsList.push("ခလဖ");
        this.tsList.push("ခဖန");
        this.tsList.push("လဂန");
        this.tsList.push("မကန");
        this.tsList.push("မကတ");
        this.tsList.push("မခဘ");
        this.tsList.push("မလန");
        this.tsList.push("မမန");
        this.tsList.push("မညန");
        this.tsList.push("မစန");
        this.tsList.push("နမန");
        this.tsList.push("ပနဒ");
        this.tsList.push("ပတအ");
        this.tsList.push("ပဝန");
        this.tsList.push("ဖကန");
        this.tsList.push("ဆဘန");
        this.tsList.push("ဆဒန");
        this.tsList.push("ဆလန");
        this.tsList.push("ဆပဘ");
        this.tsList.push("တနန");
        this.tsList.push("ဝမန");
        this.tsList.push("ရဘယ");
        this.tsList.push("ရကန");
      } else if (this.numberNo == "၂") {
        this.tsList.push("ဘလခ");
        this.tsList.push("ဒမဆ");
        this.tsList.push("လကန");
        this.tsList.push("မစန");
        this.tsList.push("ဖဆန");
        this.tsList.push("ဖရဆ");
        this.tsList.push("ရတန");
        this.tsList.push("ရသန");
      } else if (this.numberNo == "၃") {
        this.tsList.push("ဘအန");
        this.tsList.push("ဘဂလ");
        this.tsList.push("ဘကလ");
        this.tsList.push("ဘသဆ");
        this.tsList.push("ကဒန");
        this.tsList.push("ကကရ");
        this.tsList.push("ကမမ");
        this.tsList.push("ကဆက");
        this.tsList.push("လဘန");
        this.tsList.push("လသန");
        this.tsList.push("မဝတ");
        this.tsList.push("ပကန");
        this.tsList.push("ဖအန");
        this.tsList.push("ဖပန");
        this.tsList.push("စကလ");
        this.tsList.push("သတက");
        this.tsList.push("သတန");
        this.tsList.push("ဝလမ");
        this.tsList.push("ရရတ");
      } else if (this.numberNo == "၄") {
        this.tsList.push("ဟခန");
        this.tsList.push("ထတလ");
        this.tsList.push("ကခန");
        this.tsList.push("ကပလ");
        this.tsList.push("မတန");
        this.tsList.push("မတပ");
        this.tsList.push("ပလဝ");
        this.tsList.push("ဖလန");
        this.tsList.push("ဆမန");
        this.tsList.push("တတန");
        this.tsList.push("တဇန");
        this.tsList.push("ရခဒ");
        this.tsList.push("ရဇန");
      } else if (this.numberNo == "၅") {
        this.tsList.push("အတန");
        this.tsList.push("အရတ");
        this.tsList.push("ဗမန");
        this.tsList.push("ဘတလ");
        this.tsList.push("ဒဟန");
        this.tsList.push("ဒပယ");
        this.tsList.push("ဟမလ");
        this.tsList.push("ဆမရ");
        this.tsList.push("ထခန");
        this.tsList.push("ထပခ");
        this.tsList.push("ကဘလ");
        this.tsList.push("ကလထ");
        this.tsList.push("ကလန");
        this.tsList.push("ကလတ");
        this.tsList.push("ကလဝ");
        this.tsList.push("ကမန");
        this.tsList.push("ကနန");
        this.tsList.push("ကသန");
        this.tsList.push("ခဥန");
        this.tsList.push("ခဥတ");
        this.tsList.push("ခပန");
        this.tsList.push("ခတန");
        this.tsList.push("လဟန");
        this.tsList.push("လရန");
        this.tsList.push("မကန");
        this.tsList.push("မလန");
        this.tsList.push("မမန");
        this.tsList.push("မမတ");
        this.tsList.push("မပလ");
        this.tsList.push("မသန");
        this.tsList.push("မရန");
        this.tsList.push("နယန");
        this.tsList.push("ငဇန");
        this.tsList.push("ပလဘ");
        this.tsList.push("ပလန");
        this.tsList.push("ပဆန");
        this.tsList.push("ဖပန");
        this.tsList.push("စကန");
        this.tsList.push("ဆလက");
        this.tsList.push("တမန");
        this.tsList.push("တဆန");
        this.tsList.push("ဝလန");
        this.tsList.push("ဝသန");
        this.tsList.push("ရဘန");
        this.tsList.push("ယမပ");
        this.tsList.push("ရဥန");
        this.tsList.push("ရသက");
      } else if (this.numberNo == "၆") {
        this.tsList.push("ဘပန");
        this.tsList.push("ထဝန");
        this.tsList.push("ကလအ");
        this.tsList.push("ကစန");
        this.tsList.push("ကသန");
        this.tsList.push("ကရရ");
        this.tsList.push("ခမက");
        this.tsList.push("လလန");
        this.tsList.push("မအန");
        this.tsList.push("မအရ");
        this.tsList.push("မမန");
        this.tsList.push("မတန");
        this.tsList.push("ငရက");
        this.tsList.push("ပကမ");
        this.tsList.push("ပလန");
        this.tsList.push("ပလတ");
        this.tsList.push("တနသ");
        this.tsList.push("တသရ");
        this.tsList.push("သရခ");
        this.tsList.push("ရဖန");
      } else if (this.numberNo == "၇") {
        this.tsList.push("အဖန");
        this.tsList.push("အတန");
        this.tsList.push("ဒဥန");
        this.tsList.push("ထတပ");
        this.tsList.push("ကကန");
        this.tsList.push("ကပက");
        this.tsList.push("ကတခ");
        this.tsList.push("ကတတ");
        this.tsList.push("ကဝန");
        this.tsList.push("လပတ");
        this.tsList.push("မဒန");
        this.tsList.push("မလန");
        this.tsList.push("မညန");
        this.tsList.push("နတလ");
        this.tsList.push("ညလပ");
        this.tsList.push("ပခန");
        this.tsList.push("ပခတ");
        this.tsList.push("ပမန");
        this.tsList.push("ပနက");
        this.tsList.push("ပတလ");
        this.tsList.push("ပတန");
        this.tsList.push("ပတဆ");
        this.tsList.push("ပတတ");
        this.tsList.push("ဖမန");
        this.tsList.push("တငန");
        this.tsList.push("သကန");
        this.tsList.push("သနပ");
        this.tsList.push("သဆန");
        this.tsList.push("သဝတ");
        this.tsList.push("ဝမန");
        this.tsList.push("ရကန");
        this.tsList.push("ရတန");
        this.tsList.push("ရတရ");
        this.tsList.push("ဇကန");
      } else if (this.numberNo == "၈") {
        this.tsList.push("အလန");
        this.tsList.push("ဂဂန");
        this.tsList.push("ထလန");
        this.tsList.push("ကထန");
        this.tsList.push("ကမန");
        this.tsList.push("ခမန");
        this.tsList.push("မဘန");
        this.tsList.push("မထန");
        this.tsList.push("မကန");
        this.tsList.push("မလန");
        this.tsList.push("မမန");
        this.tsList.push("မတန");
        this.tsList.push("မသန");
        this.tsList.push("နမန");
        this.tsList.push("ငဖန");
        this.tsList.push("ပခက");
        this.tsList.push("ပမန");
        this.tsList.push("ပဖန");
        this.tsList.push("စကန");
        this.tsList.push("စလန");
        this.tsList.push("ဆမန");
        this.tsList.push("ဆပဝ");
        this.tsList.push("ဆဖန");
        this.tsList.push("စတရ");
        this.tsList.push("တတက");
        this.tsList.push("သရန");
        this.tsList.push("ယမန");
        this.tsList.push("ရနခ");
        this.tsList.push("ရစက");
      } else if (this.numberNo == "၉") {
        this.tsList.push("အမရ");
        this.tsList.push("အမဇ");
        this.tsList.push("ဥတသ");
        this.tsList.push("ဒခသ");
        this.tsList.push("ကမန");
        this.tsList.push("ကပတ");
        this.tsList.push("ကဆန");
        this.tsList.push("ခအဇ");
        this.tsList.push("ခမစ");
        this.tsList.push("လဝန");
        this.tsList.push("မဟမ");
        this.tsList.push("မထလ");
        this.tsList.push("မကန");
        this.tsList.push("မခန");
        this.tsList.push("မလန");
        this.tsList.push("မမန");
        this.tsList.push("မနမ");
        this.tsList.push("မနတ");
        this.tsList.push("မတရ");
        this.tsList.push("မသန");
        this.tsList.push("မရမ");
        this.tsList.push("မရတ");
        this.tsList.push("နထက");
        this.tsList.push("ငသရ");
        this.tsList.push("ငဇန");
        this.tsList.push("ညဥန");
        this.tsList.push("ပဘန");
        this.tsList.push("ပဗသ");
        this.tsList.push("ပကခ");
        this.tsList.push("ပမန");
        this.tsList.push("ပဥလ");
        this.tsList.push("ပသက");
        this.tsList.push("စကန");
        this.tsList.push("စကတ");
        this.tsList.push("တကန");
        this.tsList.push("တကတ");
        this.tsList.push("တတဥ");
        this.tsList.push("တသန");
        this.tsList.push("သပက");
        this.tsList.push("သစန");
        this.tsList.push("ဝတန");
        this.tsList.push("ရကန");
        this.tsList.push("ရမသ");
        this.tsList.push("ဇဗသ");
        this.tsList.push("ဇယသ");
      } else if (this.numberNo == "၁၀") {
        this.tsList.push("ဘလန");
        this.tsList.push("ကထန");
        this.tsList.push("ကခမ");
        this.tsList.push("ကမရ");
        this.tsList.push("ခဆန");
        this.tsList.push("ခဇန");
        this.tsList.push("လမန");
        this.tsList.push("မဒန");
        this.tsList.push("မလမ");
        this.tsList.push("ပမန");
        this.tsList.push("သထန");
        this.tsList.push("သဖရ");
        this.tsList.push("ရမန");
      } else if (this.numberNo == "၁၁") {
        this.tsList.push("အမန");
        this.tsList.push("ဘသတ");
        this.tsList.push("ဂမန");
        this.tsList.push("ကဖန");
        this.tsList.push("ကတလ");
        this.tsList.push("ကတန");
        this.tsList.push("မအန");
        this.tsList.push("မအတ");
        this.tsList.push("မဥန");
        this.tsList.push("မပန");
        this.tsList.push("မပတ");
        this.tsList.push("ပတန");
        this.tsList.push("ပဏက");
        this.tsList.push("ပဏတ");
        this.tsList.push("စတန");
        this.tsList.push("တကန");
        this.tsList.push("တပဝ");
        this.tsList.push("သတန");
        this.tsList.push("ရဗန");
        this.tsList.push("ရသတ");
        this.tsList.push("မတန");
      } else if (this.numberNo == "၁၂") {
        this.tsList.push("အလန");
        this.tsList.push("အစန");
        this.tsList.push("ဗဟန");
        this.tsList.push("ဗတထ");
        this.tsList.push("ဒဂမ");
        this.tsList.push("ဒဂန");
        this.tsList.push("ဒဂဆ");
        this.tsList.push("ဒဂတ");
        this.tsList.push("ဒဂရ");
        this.tsList.push("ဒလန");
        this.tsList.push("ဒပန");
        this.tsList.push("ထတပ");
        this.tsList.push("ကကက");
        this.tsList.push("ကခက");
        this.tsList.push("ကမန");
        this.tsList.push("ကမတ");
        this.tsList.push("ကမရ");
        this.tsList.push("ကတန");
        this.tsList.push("ကတတ");
        this.tsList.push("ခရန");
        this.tsList.push("လကန");
        this.tsList.push("လမန");
        this.tsList.push("လမတ");
        this.tsList.push("လသန");
        this.tsList.push("လသရ");
        this.tsList.push("မဘန");
        this.tsList.push("မဂဒ");
        this.tsList.push("မဂတ");
        this.tsList.push("မရက");
        this.tsList.push("ဥကမ");
        this.tsList.push("ဥကတ");
        this.tsList.push("ပဘတ");
        this.tsList.push("ပဇတ");
        this.tsList.push("ဆကခ");
        this.tsList.push("စကန");
        this.tsList.push("စခန");
        this.tsList.push("တကန");
        this.tsList.push("တမန");
        this.tsList.push("တတထ");
        this.tsList.push("တတန");
        this.tsList.push("သဃက");
        this.tsList.push("သကတ");
        this.tsList.push("သခန");
        this.tsList.push("သလန");
        this.tsList.push("ရကန");
        this.tsList.push("ရပသ");
      } else if (this.numberNo == "၁၃") {
        this.tsList.push("အပန");
        this.tsList.push("အတန");
        this.tsList.push("အသယ");
        this.tsList.push("ဟဟန");
        this.tsList.push("ဟမန");
        this.tsList.push("ဟပန");
        this.tsList.push("ဟပတ");
        this.tsList.push("ကဟန");
        this.tsList.push("ကကန");
        this.tsList.push("ကခန");
        this.tsList.push("ကလဒ");
        this.tsList.push("ကလထ");
        this.tsList.push("ကလန");
        this.tsList.push("ကလတ");
        this.tsList.push("ကမန");
        this.tsList.push("ကတလ");
        this.tsList.push("ကတန");
        this.tsList.push("ကတတ");
        this.tsList.push("ကသန");
        this.tsList.push("ခလန");
        this.tsList.push("ခရဟ");
        this.tsList.push("လကန");
        this.tsList.push("လခန");
        this.tsList.push("လခတ");
        this.tsList.push("လလန");
        this.tsList.push("လရန");
        this.tsList.push("မဘန");
        this.tsList.push("မဟရ");
        this.tsList.push("မထန");
        this.tsList.push("မထတ");
        this.tsList.push("မကန");
        this.tsList.push("မကတ");
        this.tsList.push("မခန");
        this.tsList.push("မခတ");
        this.tsList.push("မလန");
        this.tsList.push("မလတ");
        this.tsList.push("မမထ");
        this.tsList.push("မမန");
        this.tsList.push("မမတ");
        this.tsList.push("မနန");
        this.tsList.push("မငန");
        this.tsList.push("မပန");
        this.tsList.push("မပတ");
        this.tsList.push("မဖန");
        this.tsList.push("မဖတ");
        this.tsList.push("မရတ");
        this.tsList.push("မဆန");
        this.tsList.push("မစတ");
        this.tsList.push("မဆတ");
        this.tsList.push("မတန");
        this.tsList.push("မတတ");
        this.tsList.push("မယထ");
        this.tsList.push("မရန");
        this.tsList.push("မယတ");
        this.tsList.push("နဆန");
        this.tsList.push("နခန");
        this.tsList.push("နခတ");
        this.tsList.push("နမတ");
        this.tsList.push("နဖန");
        this.tsList.push("နစန");
        this.tsList.push("နတရ");
        this.tsList.push("ညရန");
        this.tsList.push("ပလန");
        this.tsList.push("ပလတ");
        this.tsList.push("ပပက");
        this.tsList.push("ပဆန");
        this.tsList.push("ပဆတ");
        this.tsList.push("ပတယ");
        this.tsList.push("ပဝန");
        this.tsList.push("ဖခန");
        this.tsList.push("ဆဆန");
        this.tsList.push("တကန");
        this.tsList.push("တခလ");
        this.tsList.push("တလန");
        this.tsList.push("တမည");
        this.tsList.push("တတန");
        this.tsList.push("တယန");
        this.tsList.push("သနန");
        this.tsList.push("သပန");
        this.tsList.push("ရငန");
        this.tsList.push("ရညန");
        this.tsList.push("ရစန");
      } else if (this.numberNo == "၁၄") {
        this.tsList.push("အဂပ");
        this.tsList.push("အမန");
        this.tsList.push("အမတ");
        this.tsList.push("ဘကလ");
        this.tsList.push("ဒဒရ");
        this.tsList.push("ဓနဖ");
        this.tsList.push("ဟကက");
        this.tsList.push("ဟသတ");
        this.tsList.push("ကကထ");
        this.tsList.push("ကကန");
        this.tsList.push("ကခန");
        this.tsList.push("ကလန");
        this.tsList.push("ကပန");
        this.tsList.push("လမန");
        this.tsList.push("လပတ");
        this.tsList.push("မအန");
        this.tsList.push("မအပ");
        this.tsList.push("မမက");
        this.tsList.push("မမန");
        this.tsList.push("ငပတ");
        this.tsList.push("ငဆန");
        this.tsList.push("ငသခ");
        this.tsList.push("ငရက");
        this.tsList.push("ညတန");
        this.tsList.push("ပစလ");
        this.tsList.push("ပတန");
        this.tsList.push("ပသအ");
        this.tsList.push("ပသန");
        this.tsList.push("ပသရ");
        this.tsList.push("ဖပန");
      }

      //this.township = this.tsList[0];
    },
    township(){
      this.getNrc();
    },
    nep(){
      this.getNrc();
    },
    nrcnumber(){
      this.getNrc();
    }
  },
  components: {
    paymentDialog,
    profileDialog,
    historyUserDialog,
  },
};
</script>
<style scoped>
.v-data-table td,
.v-data-table th {
  padding: 0 5px !important;
}
.information-window-v-sheet {
  height: 100vh !important;
  overflow-x: scroll;
}
.login-full {
  height: 93vh;
}

.fullscreen {
  height: 100vh !important;
  overflow-x: scroll;
}
</style>